import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Order } from "../../types/Sorters";
import { useTranslation } from "../../i18n";

const SorterTwoSelectBay = ({ orders, set_selectedBay, refreshList, goBack }: { orders: Order[], set_selectedBay: React.Dispatch<React.SetStateAction<string>>, refreshList: () => void, goBack: () => void }) => {
    const { t } = useTranslation();
    const [availableBays, set_availableBays] = useState<{ [key: string]: number }>({});

    useEffect(() => {

        // Reduce the orders into available bays
        const bayOrderCount: Record<string, number> = orders.reduce((hashMap, order) => {
            const bay = order.Bay;

            if (bay in hashMap) {
                hashMap[bay] += 1;
            } else {
                hashMap[bay] = 1;
            }

            return hashMap;
        }, {} as Record<string, number>);

        const sortedBayOrderCount = Object.keys(bayOrderCount).sort().reduce(
            (obj: Record<string, number>, key: string) => {
                obj[key] = bayOrderCount[key];
                return obj;
            }, {}
        );

        set_availableBays(sortedBayOrderCount);
    }, [orders]);



    return (
        <div className="page-data">
            <div className="page-title-bar">
                <h1 className="page-title">{t("select_bay")}</h1>
                <button className="page-back-btn" onClick={goBack}><ArrowLeft size={20} /></button>
            </div>

            <div className="zone-select-bay">
                {(Object.keys(availableBays).length === 0 || availableBays === undefined) && <h2>{t("no_orders_ready")}</h2>}
                {Object.keys(availableBays).length > 0 &&
                    Object.entries(availableBays).map(([bay, count]) => (
                        <button key={bay} onClick={() => set_selectedBay(bay)}>
                            <h2>{bay}</h2>
                            <h3>{t("orders_count", { count: String(count) })}</h3>
                        </button>
                    ))
                }
            </div>
        </div>
    )
};

export default SorterTwoSelectBay;
